import { Component } from 'react';
import moment from 'moment';
import { 
  CHART_REFLOW_FIRST_WAIT_TIME_IN_MILLISECONDS,
  CHART_REFLOW_SECOND_WAIT_TIME_IN_MILLISECONDS
} from './redux/constants';

class AbstractChart extends Component {

    constructor(props) {
        super(props);
        const that = this;
        this.state = {
            chartData: [],
            tickInterval: [],
            topicId: [],
            mapDataFromProps: [],
            source: [],
            filterDateRange: {
                fromDate: moment().format('YYYY-MM-DD'),
                toDate: moment().format('YYYY-MM-DD'),
            },
        }
    }

  _shouldReRenderChartBasedOnNewProps(nextProps) {
    if (nextProps.selectedTopicId == null) {
      return false;
    }
    if (this._newDateRangePropsDifferFromCurrentStateAndProps(nextProps)) {
      return true;
    }
    else if (this._newSourcePropsDifferFromCurrentStateAndProps(nextProps)) {
      return true;
    }
    else if (this._newTopicIdPropsDifferFromCurrentStateAndProps(nextProps)) {
      return true;
    }
    else {
      return false;
    }
  }

  _newDateRangePropsDifferFromCurrentStateAndProps(nextProps) {
    if (
      (JSON.stringify(this.state.filterDateRange) !== JSON.stringify(nextProps.dateRangeFilterValue)) &&
      (JSON.stringify(this.props.dateRangeFilterValue) !== JSON.stringify(nextProps.dateRangeFilterValue))
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  _newSourcePropsDifferFromCurrentStateAndProps(nextProps) {
    if (
      JSON.stringify(nextProps.source) !== JSON.stringify(this.state.source) && 
      JSON.stringify(nextProps.source) !== JSON.stringify(this.props.source)
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  _newTopicIdPropsDifferFromCurrentStateAndProps(nextProps) {
    if (
      (JSON.stringify(this.state.topicId) !== JSON.stringify(nextProps.selectedTopicId)) && 
      (JSON.stringify(this.props.selectedTopicId) !== JSON.stringify(nextProps.selectedTopicId))
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  _reflowChartAfterDelays() {
    this._reflowChartAfterSpecifiedDelay(CHART_REFLOW_FIRST_WAIT_TIME_IN_MILLISECONDS);
    this._reflowChartAfterSpecifiedDelay(CHART_REFLOW_SECOND_WAIT_TIME_IN_MILLISECONDS);
  }

  _reflowChartAfterSpecifiedDelay(millisconds) {
    const chartComponent = this.chartComponent;
    const that = this;
    window.setTimeout(
      function(){
        if (that._doesChartComponentStillExist(chartComponent)) {
            chartComponent.current.chart.reflow();
        }
      }, 
      millisconds
    );
  }

  _doesChartComponentStillExist(chartComponent) {
      if (chartComponent && chartComponent.current && chartComponent.current.chart) {
          return true;
      }
      else {
          return false;
      }
  }
}

export default AbstractChart;



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/AbstractChart.js